class UpsellCart extends HTMLElement {
  constructor() {
    super();
    this.cart = null;
    this.observer = null;
  }

  async connectedCallback() {
    this.recommendations = this.querySelector(".upsell-cart__items--recommendations");
    this.fixedCollection = this.querySelector(".upsell-collection-fixed");
    this.loading = this.querySelector(".upsell-cart__loading");

    const cartFooter = document.querySelector(".cart--footer");

    if (cartFooter && !this.observer) {
      this.observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.type === "childList" || mutation.type === "characterData")) {
          this.updateUpsell();
        }
      });

      this.observer.observe(cartFooter, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    await this.updateUpsell();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  async getCart() {
    try {
      const response = await fetch("/cart.js");
      this.cart = response.ok ? await response.json() : { items: [] };
    } catch (error) {
      console.error(error);
      this.cart = { items: [] };
    }
  }

  setHidden(element, hidden) {
    if (element) {
      element.classList.toggle("hidden", hidden);
    }
  }

  showLoading() {
    this.setHidden(this.recommendations, true);
    this.setHidden(this.fixedCollection, true);
    this.setHidden(this.loading, false);
  }

  showFixedCollection() {
    this.setHidden(this.loading, true);
    this.setHidden(this.recommendations, true);
    this.setHidden(this.fixedCollection, false);
  }

  showRecommendations() {
    this.setHidden(this.loading, true);
    this.setHidden(this.recommendations, false);
    this.setHidden(this.fixedCollection, true);
  }

  async updateUpsell() {
    this.showLoading();
    await this.getCart();

    const productId = this.cart?.items?.[0]?.product_id;
    const sectionId = this.dataset.sectionId;

    if (!productId || !sectionId) {
      this.showFixedCollection();
      return;
    }

    try {
      const response = await fetch(`${this.dataset.url}?section_id=${sectionId}&product_id=${productId}&limit=4`);

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const html = await response.text();
      const container = document.createElement("div");
      container.innerHTML = html;

      const recommendations = container.querySelector(".upsell-cart__items--recommendations");

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.recommendations.innerHTML = recommendations.innerHTML;
        this.showRecommendations();
        return;
      }

      this.showFixedCollection();
    } catch (error) {
      console.error(error);
      this.showFixedCollection();
    }
  }
}

if (!customElements.get("upsell-cart")) {
  customElements.define("upsell-cart", UpsellCart);
}
